<template>
  <div class="pta-flags">
    <div class="pta-flags__title">
      {{ capturedFlags }} of {{ flags.length }} flags captured
    </div>
    <div class="pta-flags__flag-wrapper">
      <div class="pta-flags__flag" v-for="flag in flags" :key="flag.uuid">
        <PTAFlag
          :flag="flag"
          :userFlagStatus="userFlags ? userFlags[flag.uuid] || {} : {}"
          :canSubmit="labHasStarted"
          :labsRequestPayload="labsRequestPayload"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PTAFlag from '@/components/modals/lab-modal/PTAFlag.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'PTACatchTheFlag',
  components: {
    PTAFlag,
  },
  props: {
    currentLab: {
      type: Object,
      required: true,
    },
    sessionStatus: {
      type: String,
      required: true,
    },
    labsRequestPayload: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      userFlags: 'labs/userFlags',
    }),
    flags() {
      return this.currentLab.flags
    },
    capturedFlags() {
      const captured = Object.values(this.userFlags).filter(f => {
        return f.has_passed
      })
      return captured ? captured.length : 0
    },
    labHasStarted() {
      return this.sessionStatus === CONSTANTS.LABS.SESSION_STATUS.STARTED
    },
  },
}
</script>
<style lang="scss" scoped>
.pta-flags {
  width: 100%;
  margin-bottom: 40px;
  padding: 20px;
  text-align: left;
  background: linear-gradient(
    111.02deg,
    rgba(18, 18, 18, 0.7) 3.86%,
    rgba(18, 18, 18, 0) 107.96%
  );
  border: 1px solid var(--tundora-gray);
  box-sizing: border-box;
  border-radius: 10px;
  color: var(--white);
  &__title {
    font-size: 18px;
    margin-bottom: 15px;
  }
}
</style>
